<ng-container [formGroup]="formGroup">
  <pdq-card variant="flat" color="white">
    <div class="card-container">
      <div class="card-body">
        <div class="enable-container">
          <pdq-slide-toggle
            formControlName="enabled"
            togglePosition="right"
            labelAlign="start"
            [fullWidth]="true"
            label="Shipping rate recalculation"
            subtext="Shipping costs are recalculated whenever a customer makes any qualifying change to their order."></pdq-slide-toggle>

          @if (formGroup.get('enabled').value) {
            <pdq-banner
              variant="attention"
              alignItems="center"
              [inline]="true"
              [closable]="false"
              [keepBkColor]="true"
              content="Shipping rate calculation isn't supported for multi-origin orders."></pdq-banner>
          }
        </div>

        @if (formGroup.get('enabled').value) {
          <div class="sub-controls">
            <pdq-slide-toggle
              formControlName="allowDowngrades"
              togglePosition="right"
              labelAlign="start"
              [fullWidth]="true"
              label="Allow shipping downgrades"
              subtext="When disabled, customers cannot switch to a cheaper shipping method."></pdq-slide-toggle>

            @if (formGroup.get('allowDowngrades').value) {
              <order-editing-form-refund-handling
                class="downgrade-refund-handling"
                [refundHandlingTypeControl]="formGroup.get('downgradeRefundHandlingType')"
                automaticRefundOptionText="Refund the difference automatically once the window closes"></order-editing-form-refund-handling>
            }

            <div class="eligible-methods">
              <pdq-radio-group
                formControlName="eligibleMethodsMode"
                labelVariant="field"
                [preserveTextCase]="true"
                label="Eligible shipping methods"
                secondaryLabel="Define which shipping methods can be recalculated.">
                <pdq-radio-button
                  [value]="ShippingEligibleMethodsMode.ALL"
                  [checked]="formGroup.get('eligibleMethodsMode').value === ShippingEligibleMethodsMode.ALL"
                  text="All shipping methods"></pdq-radio-button>
                <pdq-radio-button
                  [value]="ShippingEligibleMethodsMode.EXACT_NAME"
                  [checked]="formGroup.get('eligibleMethodsMode').value === ShippingEligibleMethodsMode.EXACT_NAME"
                  text="Exact match by name"></pdq-radio-button>
                <pdq-radio-button
                  [value]="ShippingEligibleMethodsMode.KEYWORD_MATCH"
                  [checked]="formGroup.get('eligibleMethodsMode').value === ShippingEligibleMethodsMode.KEYWORD_MATCH"
                  text="Keyword-based matching"></pdq-radio-button>
              </pdq-radio-group>

              @if (formGroup.get('eligibleMethodsMode').value !== ShippingEligibleMethodsMode.ALL) {
                <div class="method-names">
                  <pdq-textarea
                    label="Method names, one per line"
                    [control]="methodNamesControl"
                    [rows]="3"></pdq-textarea>
                </div>
              }
            </div>

            <div class="minimum-charge-threshold">
              <p class="body-14-medium">Minimum charge threshold</p>
              <p class="body-12-regular input-subtext">
                Charge the customer only when the increase is at least this much. Smaller increases are absorbed.
              </p>
              <pdq-input-arrows
                formControlName="minimumChargeThreshold"
                [symbol]="currencySymbol"
                [min]="0"
                [step]="1"
                [precision]="0"
                widthSize="xxlarge"></pdq-input-arrows>
              <p class="body-12-regular input-subtext">Set to 0 to always charge.</p>
            </div>
          </div>
        }
      </div>
    </div>
  </pdq-card>
</ng-container>
